import { ScopeLoadingState } from "./types";

export const isScopeLoading = <T = string>(
  loading: ScopeLoadingState<T>,
  scope: T
): boolean =>
  loading && Array.isArray(loading) && loading.some((id: T) => id === scope);
